import React, { useEffect, useRef, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const DashboardSettings = () => {
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const [audioDevices, setAudioDevices] = React.useState<any>("")
    const [softphoneEnabled, setSoftphoneEnabled] = React.useState<any>("")
    const [extension, setExtension] = React.useState<any>("")
    const timerRef = useRef<any>(null);
    const [successAlert, setSuccessAlert] = useState(false)
    const [failedAlert, setFailedAlert] = useState(false)
    const [speakerDeviceId, setSpeakerDeviceId] = useState<any>("")
    const [ringerDeviceId, setRingerDeviceId] = useState<any>("")
    const [microphoneDeviceId, setMicrophoneDeviceId] = useState<any>("")
    const [dialpadSounds, setDialpadSounds] = useState<any>("")

    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    
    useEffect(()=>{
        let speakerDeviceIdValue = localStorage.getItem("speakerDeviceId") || "";
        setSpeakerDeviceId(speakerDeviceIdValue);
        let microphoneDeviceIdValue = localStorage.getItem("microphoneDeviceId") || "";
        setMicrophoneDeviceId(microphoneDeviceIdValue);
        let ringerDeviceIdValue = localStorage.getItem("ringerDeviceId") || "";
        setRingerDeviceId(ringerDeviceIdValue);
        let dialPadSoundsValue = localStorage.getItem("dialpadSounds") || "";
        setDialpadSounds(dialPadSoundsValue);
        if(audioDevices === "") {
            connect.core.getFrameMediaDevices(1000).then(function(deviceList){
                setAudioDevices(deviceList)
            }).catch((err)=>{
                console.log("abc-"+err)
            })
        }
        if(agentObj) {
            setSoftphoneEnabled(agentObj.isSoftphoneEnabled())
            setExtension(agentObj.getExtension())
        }
        return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const onSetSpeakerDevice = (event:any) => {
        const deviceId = event.target.value;
        localStorage.setItem("speakerDeviceId", deviceId)
        setSpeakerDeviceId(deviceId);
        console.log(deviceId)
        agentObj?.setSpeakerDevice(deviceId)
    }

    const onSetMicrophoneDevice = (event:any) => {
        const deviceId = event.target.value;
        localStorage.setItem("microphoneDeviceId", deviceId)
        setMicrophoneDeviceId(deviceId);
        agentObj?.setMicrophoneDevice(deviceId);
    }

    const onSetRingerDevice = (event:any) => {
        const deviceId = event.target.value;
        localStorage.setItem("ringerDeviceId", deviceId)
        setRingerDeviceId(deviceId);
        console.log(deviceId)
        agentObj?.setRingerDevice(deviceId);
    };

    const onSetDialpadSounds = (event:any) => {
        const value = event.target.value;
        localStorage.setItem("dialpadSounds", value);
        setDialpadSounds(value)
        console.log(value);
        agentObj?.setDialPadSounds(value);
    }

    const onSaveConfig = () => {
        let configData = agentObj?.getConfiguration()
        if(softphoneEnabled){
            configData.extension = "";
            configData.agentPreferences.locale = "en_US";
            configData.softphoneEnabled = softphoneEnabled;

        } else {
            configData.extension = extension;
            configData.agentPreferences.locale = "en_US";
            configData.softphoneEnabled = softphoneEnabled;
        }
        agentObj?.setConfiguration(configData, {
            success:function(){
                setSuccessAlert(true)
                timerRef.current = setTimeout(() => setSuccessAlert(false), 5000);
                console.log("Agent configData Change")
            },
            failure:function(err:any){
                setFailedAlert(true)
                timerRef.current = setTimeout(() => setFailedAlert(false), 5000);
                console.log(err)
                console.log("Failed to Change configData")
            }
        })
    }

    const onChangeExtension = (event:any) => {
        let dialNumber = event.target.value;
        setExtension(dialNumber)
    }

    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="widgetSettings">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Call Settings</h6>
                </div>
                <div className="card-body min-height-400">
                        {successAlert && <Alert variant="success" onClose={() => setSuccessAlert(false)} dismissible>
                            <strong>Data saved successfully</strong>
                        </Alert>}

                        {failedAlert && <Alert variant="danger" onClose={() => setSuccessAlert(false)} dismissible>
                            <strong>Failed to update</strong>
                        </Alert>}
                    <form onSubmit={e => e.preventDefault()} onKeyPress={(e)=>{if (e.key ==="Enter"){onSaveConfig()}}}>
                        <div className="mb-3 mt-3">
                            <label className="form-label">Speaker</label>
                            <select className="form-select" value={speakerDeviceId || ''} onChange={(event)=>{onSetSpeakerDevice(event)}}>
                                {audioDevices && audioDevices.filter((device:any)=>{return device.kind === "audiooutput"}).map((device:any)=>{
                                    return (<option key={device.deviceId} value={device.deviceId}>{device.label}</option>)
                                })}
                            </select>
                        </div>
                        <div className="mb-3 mt-3">
                            <label className="form-label">Microphone</label>
                            <select className="form-select" value={microphoneDeviceId || ''} onChange={(event)=>{onSetMicrophoneDevice(event)}}>
                                {audioDevices && audioDevices.filter((device:any)=>{return device.kind === "audioinput"}).map((device:any)=>{
                                    return (<option key={device.deviceId} value={device.deviceId}>{device.label}</option>)
                                })}
                            </select>
                        </div>
                        <div className="mb-3 mt-3">
                            <label className="form-label">Ringer</label>
                            <select className="form-select" value={ringerDeviceId || ''} onChange={(event)=>{onSetRingerDevice(event)}}>
                                {audioDevices && audioDevices.filter((device:any)=>{return device.kind === "audiooutput"}).map((device:any)=>{
                                    return (<option key={device.deviceId} value={device.deviceId}>{device.label}</option>)
                                })}
                            </select>
                        </div>
                        <div className="mb-3 mt-3">
                            <label className="form-label">Dialpad Sounds</label>
                            <select className="form-select" value={dialpadSounds || ''} onChange={(event)=>{onSetDialpadSounds(event)}}>
                                <option key="true" value="true">{"Enabled"}</option>
                                <option key="false" value="false">{"Disabled"}</option>
                            </select>
                        </div>
                        <div className="form-check mt-3">
                            <label className="form-check-label">
                            <input type="radio" value="Softphone" onChange={(e) =>setSoftphoneEnabled(true)} checked={softphoneEnabled}  className="form-check-input" /> Softphone
                            </label>
                        </div>
                        <div className="form-check mb-3">
                            <label className="form-check-label">
                            <input type="radio" value="Deskphone" onChange={(e) =>setSoftphoneEnabled(false)} checked={!softphoneEnabled} className="form-check-input" /> Desk phone
                            </label>
                        </div>
                            
                        {(!softphoneEnabled) && <div className="mb-3 mt-3">
                            <label className='form-label'>Number</label>
                            <input onChange={onChangeExtension} value={extension} className="form-control" type="text"></input>
                        </div> }
                        <button onClick={()=>{onSaveConfig()}} type="button" className="btn btn-primary">Save</button>
                    </form>
                </div>
            </div>
        </React.Fragment>      
    )
}
export default DashboardSettings;
